import {
  COLORS,
  Icon,
  IconName,
  tabletAndUp,
  Text,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

export const BodyHeaderSection: FC<{
  headline: string;
  subline: string;
  iconName: IconName;
  reduceBottomSpace?: boolean;
  'data-testid'?: string;
  darkMode?: boolean;
  className?: string;
}> = ({
  headline,
  subline,
  iconName,
  reduceBottomSpace,
  'data-testid': dataTestId,
  darkMode,
  className,
}) => {
  return (
    <ContentHeader
      $reduceBottomSpace={reduceBottomSpace}
      data-testid={dataTestId}
      className={className}
    >
      <CouponIcon data-dark-mode={darkMode}>
        <Icon
          asset={iconName}
          size="S"
          fill={darkMode ? COLORS.PrimaryCoupon : COLORS.White}
        />
      </CouponIcon>
      <Headline size="px24" weight="heavy" data-dark-mode={darkMode}>
        {headline}
      </Headline>
      <Subline size="px12" weight="mediumBold" data-dark-mode={darkMode}>
        {subline}
      </Subline>
    </ContentHeader>
  );
};

const Headline = styled(Text)<{$enableEvenSpacing?: boolean}>`
  line-height: 1.16667;

  &[data-dark-mode='true'] {
    color: ${COLORS.White};
  }
`;

const Subline = styled(Text)`
  line-height: 1.5;

  &[data-dark-mode='true'] {
    color: ${COLORS.White};
  }
`;

const CouponIcon = styled.div<{
  $reduceSize?: boolean;
  $enableEvenSpacing?: boolean;
}>`
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${COLORS.PrimaryCoupon};
  width: 40px;

  &[data-dark-mode='true'] {
    background-color: ${COLORS.White};
  }
`;

const ContentHeader = styled.div<{
  $enableEvenSpacing?: boolean;
  $reduceBottomSpace?: boolean;
}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 32px 16px 64px 16px;
  text-align: center;
  gap: 12px;

  ${tabletAndUp(css`
    padding-bottom: 48px;
  `)}

  ${({$reduceBottomSpace}) =>
    $reduceBottomSpace &&
    css`
      && {
        padding-bottom: 12px;
      }
    `}
`;
